import React from 'react';
/**
 * @jest-environment jsdom
 */

import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'jl-design-system/elements/button/Button';
import CloseButtonJB from 'jl-design-system/elements/icons-jb/Close24PxOutlined';
import styles from './FlyoutMenu.scss';

const CloseButton = ({ onClose }) => {
  const CloseIcon = CloseButtonJB;

  return (
    <Button
      className={classNames(styles.close)}
      onClick={onClose}
      data-testid="nav-close-button"
    >
      <CloseIcon box title="Close" />
      <span className={styles.visuallyHidden}>Close</span>
    </Button>
  );
};

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CloseButton;
